// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#767676","primaryColorLight":"#7e7e7e","spinner":"styles_spinner__H782g","noPadding":"styles_noPadding__ZUhRx"};